var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field",
      class: [
        {
          "has-error": _vm.v && _vm.v.$anyError && _vm.type != "ADDRESS",
          "form-search": _vm.type == "SEARCH",
          "form-wysiwyg": _vm.type == "WYSIWYG",
          "is-required": _vm.isRequired,
        },
        _vm.classes,
      ],
      attrs: { disabled: _vm.iniDisabled },
    },
    [
      _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "field has-addons": _vm.hasAddons,
          },
        },
        [
          _vm.hasPrepend
            ? _c(
                "div",
                { staticClass: "control prepend" },
                [
                  _vm._t("prepend"),
                  _vm._v(" "),
                  _vm.type == "BELGIANENTERPRISENUMBER"
                    ? [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v(" BE "),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control is-expanded" },
            [
              _vm.showDisabled
                ? [
                    _vm.type == "WYSIWYG"
                      ? [
                          _c("div", {
                            ref: "wysiwyg",
                            class: [
                              _vm.showCondensed ? "condensed" : "",
                              !_vm.value ? "empty" : "wysiwyg",
                              _vm.hasScrollBar ? "has-scroll" : "",
                            ],
                            domProps: { innerHTML: _vm._s(_vm.value) },
                          }),
                        ]
                      : _vm.type == "PASSWORD"
                      ? [
                          _c("div", { staticClass: "control is-clearfix" }, [
                            _c("input", {
                              ref: "input",
                              staticClass: "input",
                              attrs: {
                                type: "password",
                                autocomplete: "off",
                                disabled: "disabled",
                              },
                              domProps: { value: _vm.selected },
                            }),
                          ]),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "input disabled" },
                            [
                              _vm.type == "EMAIL"
                                ? [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "txt",
                                        attrs: {
                                          href: `mailto:${_vm.selected}`,
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.selected))]
                                    ),
                                  ]
                                : _vm.type == "URI"
                                ? [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "txt",
                                        attrs: { href: `${_vm.selected}` },
                                      },
                                      [_vm._v(_vm._s(_vm.selected))]
                                    ),
                                  ]
                                : _vm.type == "PHONE"
                                ? [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "txt",
                                        attrs: { href: `tel:${_vm.selected}` },
                                      },
                                      [_vm._v(_vm._s(_vm.selected))]
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.selected) +
                                        "\n                        "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ],
                  ]
                : [
                    _vm.type == "TEXT"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix",
                              class: { "has-icons-left": !!this.$slots.icon },
                            },
                            [
                              !!this.$slots.icon
                                ? _c(
                                    "span",
                                    { staticClass: "icon is-left" },
                                    [_vm._t("icon")],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("input", {
                                ref: "input",
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  autocomplete: "on",
                                  placeholder: _vm.placeholder,
                                },
                                domProps: { value: _vm.selected },
                                on: {
                                  input: _vm.onChange,
                                  focus: (event) => {
                                    _vm.$emit("focus", event)
                                  },
                                  blur: (event) => {
                                    _vm.$emit("blur", event)
                                  },
                                  keyup: (event) => {
                                    _vm.$emit("keyup", event)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == "TEXTAREA"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix",
                              class: { "has-icons-left": !!_vm.$slots.icon },
                            },
                            [
                              !!_vm.$slots.icon
                                ? _c(
                                    "span",
                                    { staticClass: "icon is-left" },
                                    [_vm._t("icon")],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("textarea", {
                                ref: "input",
                                staticClass: "input",
                                attrs: {
                                  cols: _vm.cols,
                                  rows: _vm.rows,
                                  placeholder: _vm.placeholder,
                                },
                                domProps: { value: _vm.selected },
                                on: {
                                  input: _vm.onChange,
                                  focus: (event) => {
                                    _vm.$emit("focus", event)
                                  },
                                  blur: (event) => {
                                    _vm.$emit("blur", event)
                                  },
                                  keyup: (event) => {
                                    _vm.$emit("keyup", event)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == "SEARCH"
                      ? [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control search has-icons-left is-clearfix has-icons-right",
                              },
                              [
                                _c("input", {
                                  staticClass: "input",
                                  attrs: {
                                    type: "search",
                                    autocomplete: "on",
                                    placeholder: _vm.$t("search"),
                                  },
                                  domProps: { value: _vm.selected },
                                  on: { input: _vm.onChange },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "icon is-left" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "magnifying-glass"],
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.iniDisabled && _vm.selected
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "icon is-right is-clickable",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.onClearSearch.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fas", "times"] },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      : _vm.type == "PASSWORD"
                      ? [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "control search has-icons-left is-clearfix",
                              },
                              [
                                _c("input", {
                                  staticClass: "input",
                                  attrs: {
                                    type: "password",
                                    autocomplete: "off",
                                  },
                                  domProps: { value: _vm.selected },
                                  on: { input: _vm.onChange },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "icon is-left" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "lock"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      : _vm.type == "NUMBER"
                      ? [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c("input", {
                              staticClass: "input",
                              attrs: {
                                type: "number",
                                step: "any",
                                min: _vm.min,
                                max: _vm.max,
                              },
                              domProps: { value: _vm.selected },
                              on: { input: _vm.onChange },
                            }),
                          ]),
                        ]
                      : _vm.type == "EMAIL"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix has-icons-left",
                            },
                            [
                              _c("input", {
                                staticClass: "input",
                                attrs: { type: "email", autocomplete: "on" },
                                domProps: { value: _vm.selected },
                                on: { input: _vm.onChange },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "icon is-left" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["far", "envelope-open"] },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm.type == "URI"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix has-icons-left",
                            },
                            [
                              _c("input", {
                                staticClass: "input",
                                attrs: { type: "url", autocomplete: "on" },
                                domProps: { value: _vm.selected },
                                on: { input: _vm.onChange },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "icon is-left" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "globe"] },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm.type == "WYSIWYG"
                      ? [
                          _c("wysiwyg", {
                            attrs: { disabled: _vm.iniDisabled },
                            on: { input: _vm.onChangeWysiwyg },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ]
                      : _vm.type == "CUSTOM"
                      ? [_vm._t("custom")]
                      : _vm.type == "ADDRESS"
                      ? [
                          _c("addressForm", {
                            attrs: {
                              iniDisabled: _vm.iniDisabled,
                              v: _vm.v,
                              hideActions: true,
                              hideMessages: true,
                              hideChanges: true,
                              iniData: _vm.selected,
                              isCollapsed: _vm.isCollapsed,
                              usePopover: _vm.showCondensed,
                              autoComplete: _vm.autoComplete,
                            },
                            on: {
                              input: _vm.onAddressChange,
                              placeSelected: (value) => {
                                _vm.$emit("placeSelected", value)
                              },
                            },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ]
                      : _vm.type == "PHONE"
                      ? [
                          _c("inputPhone", {
                            attrs: {
                              v: _vm.v,
                              iniDisabled: _vm.iniDisabled,
                              country: _vm.country,
                            },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ]
                      : _vm.type == "INSS"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix",
                              class: { "has-icons-left": !_vm.iniDisabled },
                            },
                            [
                              !_vm.iniDisabled
                                ? _c(
                                    "span",
                                    { staticClass: "icon is-left" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fas", "address-card"],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: _vm.maskNationalnumber,
                                    expression: "maskNationalnumber",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected,
                                    expression: "selected",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  disabled: _vm.iniDisabled,
                                },
                                domProps: { value: _vm.selected },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.selected = $event.target.value
                                    },
                                    _vm.onChange,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm.type == "BE_NO_PREFIX_INSS"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix",
                              class: { "has-icons-left": !_vm.iniDisabled },
                            },
                            [
                              !_vm.iniDisabled
                                ? _c(
                                    "span",
                                    { staticClass: "icon is-left" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fas", "address-card"],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: _vm.masBEkNationalnumberNoPrefix,
                                    expression: "masBEkNationalnumberNoPrefix",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected,
                                    expression: "selected",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  disabled: _vm.iniDisabled,
                                },
                                domProps: { value: _vm.selected },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.selected = $event.target.value
                                    },
                                    _vm.onChange,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm.type == "BELGIANENTERPRISENUMBER"
                      ? [
                          _c("input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: _vm.maskBelgianEnterprisenumber,
                                expression: "maskBelgianEnterprisenumber",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected,
                                expression: "selected",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "text", disabled: _vm.iniDisabled },
                            domProps: { value: _vm.selected },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.selected = $event.target.value
                                },
                                _vm.onChange,
                              ],
                            },
                          }),
                        ]
                      : _vm.type == "IBAN"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "control is-clearfix",
                              class: { "has-icons-left": !_vm.iniDisabled },
                            },
                            [
                              !_vm.iniDisabled
                                ? _c(
                                    "span",
                                    { staticClass: "icon is-left" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "university"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: _vm.maskIbanNumber,
                                    expression: "maskIbanNumber",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selected,
                                    expression: "selected",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  disabled: _vm.iniDisabled,
                                },
                                domProps: { value: _vm.selected },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.selected = $event.target.value
                                    },
                                    _vm.onChange,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          !!this.$slots.append
            ? _c(
                "div",
                { staticClass: "control append" },
                [_vm._t("append")],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.v && _vm.v.$anyError
        ? _c("span", { staticClass: "help is-danger" }, [_vm._t("onError")], 2)
        : _vm._e(),
      _vm._v(" "),
      !!this.$slots.help
        ? _c("span", { staticClass: "help info" }, [_vm._t("help")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }